module.exports = __webpack_public_path__ + "img/icon_help.32e31592.svg";